var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponNotfound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 196,
    viewBox: "0 0 188 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.776 0C177.416 2.95379e-07 187.662 10.2634 187.662 22.924V83.6725C180.078 83.6725 173.931 89.8306 173.931 97.4269C173.931 105.023 180.078 111.181 187.662 111.181V173.076C187.662 185.737 177.416 196 164.776 196H22.8856C10.2462 196 9.21574e-08 185.737 0 173.076L0 111.181C7.58363 111.181 13.7314 105.023 13.7314 97.4269C13.7314 89.8306 7.58363 83.6725 0 83.6725L0 22.924C0 10.2634 10.2462 2.95379e-07 22.8856 0L164.776 0Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponNotfound);
export default __webpack_public_path__ + "static/media/coupon_notfound.59c6fb9ff1e6871327e768f6f387b4f3.svg";
export { ForwardRef as ReactComponent };